import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { DetailsSidebar } from '@/modules/transaction/components/DetailsSidebar';
import { TermsSignature } from '@/modules/common/components/TermsSignature';

import {
  termsSignature,
  IInvestmentReview,
  IDetails,
  ITermSignature
} from '@/modules/transaction/services/product-investment';

import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { isImpersonate } from '@/modules/common/services/partner';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStep',
  setup(__props) {

const investmentReview = inject('investmentReview') as Ref<IInvestmentReview>;
const termSignatureData = inject('termSignatureData') as Ref<ITermSignature>;
const isFetchingInvestment = inject('isFetchingInvestment') as Ref<boolean>;

const fetchInvestment = inject('fetchInvestment', () => ({}));

const isLoading = ref(false);
const isTermSignatureOpen = ref(false);
const isDetailsOpen = ref(false);
const sidebarDetails = ref<IDetails>({
  title: '',
  description: '',
  button: null
});

function openDetails(details: IDetails | null) {
  if (!details) return;

  sidebarDetails.value = details;
  isDetailsOpen.value = true;
}

function handleClick() {
  if (
    termSignatureData.value.requestTermsSignature.length > 0 &&
    !isImpersonate()
  ) {
    isTermSignatureOpen.value = true;

    return;
  }

  fetchInvestment();
}

async function acceptTerms() {
  isTermSignatureOpen.value = false;

  try {
    isLoading.value = true;

    await termsSignature(
      termSignatureData.value.requestTermsSignature[0].productId
    );
    fetchInvestment();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,investmentReview, termSignatureData, isFetchingInvestment, fetchInvestment, isLoading, isTermSignatureOpen, isDetailsOpen, sidebarDetails, openDetails, handleClick, acceptTerms, HeadingDisplay, ContentDisplay, Heading, ListDisplay, ButtonContainer, ButtonPrimary, DetailsSidebar, TermsSignature }
}

})